module.exports = __webpack_public_path__ + "img/girl.3c2cd502.webp";